import {
  IFoDangKyAnHocSinh,
} from "../models/response/thuc-don/IFoDangKyAnHocSinh";
import { IReadUploadedExcelFileRequest } from "../models/request/upload-file/IReadUploadedExcelFileRequest";
import { apiClient } from "./apiClient";
import { IDangKyAnImportRequest } from "../models/request/thuc-don/IDangKyAnImportRequest";
import { IBaoCaoAnRequest } from "../models/request/thuc-don/IBaoCaoAnRequest";

export const FO_DANG_KY_AN_HOC_SINH_API_END_POINT = "food/dang-ky-hoc-sinh";
export const FO_BAOCAO_AN_HOC_SINH_API_END_POINT = "food/bao-cao";

export const foDangKyAnHocSinhApi = {
  select_all: () => apiClient.get(FO_DANG_KY_AN_HOC_SINH_API_END_POINT),
  select_by_id: (id: number) =>
    apiClient.get(`${FO_DANG_KY_AN_HOC_SINH_API_END_POINT}/${id}`),
  select_by_coso_namhoc: (dm_coso_id: number, nam_hoc: string) =>
    apiClient.get(
      `${FO_DANG_KY_AN_HOC_SINH_API_END_POINT}/co-so/${dm_coso_id}/nam-hoc/${nam_hoc}`
    ),
    select_by_baocao: (data: IBaoCaoAnRequest) =>
    apiClient.post(
      `${FO_BAOCAO_AN_HOC_SINH_API_END_POINT}/ngay`, data
    ),
    select_by_baocao_thang: (data: IBaoCaoAnRequest) =>
    apiClient.post(
      `${FO_BAOCAO_AN_HOC_SINH_API_END_POINT}/thang`, data
    ),
    select_by_baocao_xinnghi: (data: IBaoCaoAnRequest) =>
    apiClient.post(
      `${FO_BAOCAO_AN_HOC_SINH_API_END_POINT}/xin-nghi`, data
    ),
        select_by_baocao_diemdanh: (data: IBaoCaoAnRequest) =>
    apiClient.post(
      `${FO_BAOCAO_AN_HOC_SINH_API_END_POINT}/diem-danh`, data
    ),
  insert: (data: IFoDangKyAnHocSinh) =>
    apiClient.post(FO_DANG_KY_AN_HOC_SINH_API_END_POINT, data),
  update: (data: IFoDangKyAnHocSinh) =>
    apiClient.put(FO_DANG_KY_AN_HOC_SINH_API_END_POINT, data),
  savechanges: (data: IFoDangKyAnHocSinh) =>
    apiClient.post(`${FO_DANG_KY_AN_HOC_SINH_API_END_POINT}/savechanges`, data),
  LoadFromExcel(request: FormData) {
    return apiClient.upload(
      `${FO_DANG_KY_AN_HOC_SINH_API_END_POINT}/import/load-from-excel`,
      request
    );
  },
  SaveDataExcel(request: IDangKyAnImportRequest) {
    return apiClient.post(
      `${FO_DANG_KY_AN_HOC_SINH_API_END_POINT}/import/save-data-excel`,
      request
    );
  },
  updateTrangThaiBatch(request: {
    ids: number[];
    dm_trangthai_dangkyan_id: number;
    ngay_phe_duyet?: Date;
    nguoi_phe_duyet?: number;
  }) {
    return apiClient.post(
      `${FO_DANG_KY_AN_HOC_SINH_API_END_POINT}/update-trangthai-batch`,
      request
    );
  },
  delete: (id: number) =>
    apiClient.delete(`${FO_DANG_KY_AN_HOC_SINH_API_END_POINT}/${id}`),
};
